var _a;
import { AppBarComponentFallback } from '@office-start/appbar-component';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
import { getSchedulingPriorityForAppBar } from '../../utils';
import { appbarConnectorService } from '../AppHostPage/AppHostPage';
var AppBarLazy = withLazyErrorBoundary(lazy(function () {
    return import(
    /*webpackChunkName: "appbar" */ '@office-start/appbar-component');
}), 'AppBar', {
    schedulePriority: getSchedulingPriorityForAppBar((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname),
    fallback: AppBarComponentFallback,
});
export var AppBar = function () {
    return React.createElement(AppBarLazy, { appbarConnectorService: appbarConnectorService });
};
//# sourceMappingURL=AppBar.js.map